/* PLTX2 section scroll reveal — product templates.
   Sections already on screen at load never animate (no LCP cost);
   everything below the fold fades up once as it enters. Skipped in
   the theme editor (sections re-render there) and for reduced motion. */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var root = document.querySelector('main') || document;
  var sections = root.querySelectorAll('.shopify-section');
  if (!sections.length) return;

  document.documentElement.classList.add('pltx2-reveal-on');

  var io = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('pltx2-revealed');
          io.unobserve(entries[i].target);
        }
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.03 }
  );

  for (var i = 0; i < sections.length; i++) {
    var rect = sections[i].getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.85) continue;
    sections[i].classList.add('pltx2-reveal-wait');
    io.observe(sections[i]);
  }
})();
